import { Switch, SwitchProps } from '@anytag/shared-atoms';
import { DefaultFieldProps } from './types';
import { useFormatRHFFieldProps } from './hooks';
import { RHFFieldWrapper } from './shared';

export type SwitchToggleFieldProps<T extends string = string> = DefaultFieldProps<T, boolean> &
  Pick<SwitchProps, 'label' | 'hint'>;

export const SwitchToggleField = <T extends string>(props: SwitchToggleFieldProps<T>) => {
  const {
    setValueOptions,
    fieldWrapperProps,
    formContext: { setValue },
    fieldProps: { name, value, label, disabled, hint, onChange }
  } = useFormatRHFFieldProps(props);

  return (
    <RHFFieldWrapper {...fieldWrapperProps} iconMargin="10px">
      <Switch
        label={label}
        hint={hint}
        checked={value}
        disabled={disabled}
        onChange={() => (onChange ? onChange(name, !value) : setValue<string>(name, !value, setValueOptions))}
      />
    </RHFFieldWrapper>
  );
};
